
{
  "fr": {
    "ConfiguratorEditorProductTab": {
      "title": "Produit",
      "useCustomTheme": "Choisir parmi nos 750+ modèles à personnaliser",
      "replaceCustomTheme": "Changer mon visuel",
      "selectedProduct": "Style de personnalisation :"
    }
  }
}
